import { ConfirmModal } from '../../../shared/modal'

type ConfirmPublishTemplateModalProps = {
  /** Determines visibility of modal */
  isOpen: boolean
  /** Label of template to delete */
  label: string
  /** Event callback when Confirm Button is triggered */
  onConfirm: () => void
}

const ConfirmPublishTemplateModal = ({
  isOpen,
  label,
  onConfirm
}: ConfirmPublishTemplateModalProps) => (
  <ConfirmModal
    confirmText={`Publish ${label}`}
    isOpen={isOpen}
    onConfirm={onConfirm}
    title={`Publish ${label}`}
  >
    Are you sure you want to publish this {label.toLowerCase()}?
    <p>
      You will not be able to edit a {label.toLowerCase()} after it’s published. All users with
      access to the {label.toLowerCase()} library will be able to see the {label.toLowerCase()} and
      share it with students.
    </p>
  </ConfirmModal>
)

export default ConfirmPublishTemplateModal
